// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"93305dbb","891":"4bca6723"}[chunkId] + ".chunk.js";
};